/**
 * Calculate reading time from HTML content.
 * Average reading speed for French: ~200 words/minute.
 */
export function getReadingTime(htmlContent) {
  if (!htmlContent) return 0;
  const text = htmlContent.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  const wordCount = text.split(" ").filter(Boolean).length;
  return Math.max(1, Math.ceil(wordCount / 200));
}
